import Typography from "../../typography/typography";
import images from "../../../assets/images";
import { Box, Tab, Tabs } from "@mui/material";
import { SyntheticEvent, useState } from "react";

function SharedPageView(props: any) {
  const { pageValue, pages, onChange } = props;
  const [value, setValue] = useState(pages[pageValue]?.viewStyle - 1);

  const handleChange = (_event: SyntheticEvent, newValue: number) => {
    setValue(newValue);
    onChange(newValue + 1);
  };

  const renderContentView = () => {
    switch (value) {
      case 0:
        return (
          <img
            className="shared-img"
            src={images.sharedPage.kanbanView}
            alt="Kanban View"
          />
        );
      case 1:
        return (
          <img
            className="shared-img"
            src={images.sharedPage.calendarView}
            alt="Gantt View"
          />
        );
      case 2:
        return (
          <img
            className="shared-img"
            src={images.sharedPage.tableView}
            alt="Grid View"
          />
        );
      case 3:
        return (
          <img
            className="shared-img"
            src={images.sharedPage.ganttView}
            alt="Table View"
          />
        );
      case 4:
        return (
          <img
            className="shared-img"
            src={images.sharedPage.gridView}
            alt="Calendar View"
          />
        );
      default:
        return null;
    }
  };

  const renderViewName = (index: number) => {
    switch (index) {
      case 0:
        return value === 0 ? "Kanban View" : "1";
      case 1:
        return value === 1 ? "Calendar View" : "2";
      case 2:
        return value === 2 ? "List View" : "3";
      case 3:
        return value === 3 ? "Timeline View" : "4";
      case 4:
        return value === 4 ? "Grid" : "5";
      default:
        return "";
    }
  };

  return (
    <>
      <div className="shared-img-wrap">
        <Typography>{renderContentView()}</Typography>
        <div className="shared-img-tab">
          <Box sx={{ width: "100%" }}>
            <Tabs value={value} onChange={handleChange} centered>
              <Tab key={0} label={renderViewName(0)} />
              <Tab key={1} label={renderViewName(1)} />
              <Tab key={2} label={renderViewName(2)} />
              <Tab key={3} label={renderViewName(3)} />
              <Tab key={4} label={renderViewName(4)} />
            </Tabs>
          </Box>
        </div>
      </div>
    </>
  );
}

export { SharedPageView };
export default SharedPageView;
